module.exports = __webpack_public_path__ + "static/img/index.c96aaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vibrate/IEPE/index.png
// module id = 4yfP
// module chunks = 0